<div *ngIf="type === 'overlay'"
  [style.visibility]= "shouldBeVisible ? 'visible' : 'hidden'"
  class="toolbox-overlay">
  <div class='background'></div>

  <mat-card
       [ngClass]='["toolbox", type, "gallery",
                   displayTitle ? "w-title" : "wo-title"]'>
    <mat-card-header>
      <mat-card-title *ngIf="displayTitle">
        {{ 'i18n.toolbox.gallery.title' | translate }}
      </mat-card-title>
      <mat-icon svgIcon="close"
                class="close-x"
                (click)="btnCancelClick()"></mat-icon>
    </mat-card-header>

    <mat-card-content [ngClass]='["gallery-container"]'>
      <gallery (imageClicked)="changeImage($event)"></gallery>
    </mat-card-content>
    <mat-card-actions [ngClass]='["buttons"]'
        *ngIf="type === 'overlay'">
      <button mat-raised-button (click)="btnOKClick()"
              size="small"
              translate>
        i18n.button.close
      </button>

      <div class="button image-select" *ngIf="showUploadButton">
        <input imageUpload #imageSelect id="image-select" type="file"
               multiple accept="image/*"/>
        <button mat-raised-button color="primary"
                size="small"
                (click)="imageSelect.click(); trackUploadPhotos();" translate>
          i18n.button.uploadPhotos
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>

<div class="toolbox-static" *ngIf="type === 'static'">
  <div class="header">
    <ng-container *ngIf="displayTitle">
      <span *ngIf="displayTitle" class="title">
        <mat-icon svgIcon="photos"></mat-icon>
        {{ 'i18n.toolbox.gallery.title' | translate }}
      </span>
      <hr class="title-hr" />
    </ng-container>
  </div>
  <div class="body" [ngClass]='["gallery-container"]'>
    <gallery (imageClicked)="changeImage($event)"></gallery>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/toolboxes/gallery-toolbox/gallery-toolbox.component.html